import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable'; // Correct import for creatable select
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const TagSelect = ({ selectedTags, setSelectedTags }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    // Fetch tags from the server
    fetch(`${process.env.REACT_APP_API_URL}/tags`)
      .then(response => response.json())
      .then(data => {
        // Map the data to match the react-select format
        const tagOptions = data.map(tag => ({
          value: tag.tag,
          label: tag.tag
        }));
        console.log('Tag options:', tagOptions);
        setOptions(tagOptions);
      })
      .catch(error => {
        console.error('Error fetching tags:', error);
      });
  }, []);

  const handleChange = (selected) => {
    setSelectedTags(selected || []);
  };

  return (
    <CreatableSelect
      components={animatedComponents}
      isMulti
      options={options}
      value={selectedTags}
      onChange={handleChange}
      placeholder="Selecteaza tag-uri existente sau tasteaza pentru a adauga altele noi"
      formatCreateLabel={(inputValue) => `Creeaza "${inputValue}"`}
    />
  );
};

export default TagSelect;
